import React from "react";
import { useTranslation } from "react-i18next";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import PageSection from "../components/PageSection";

interface Person { role: string; name: string; body: string }
type Row = [string, string];

const CompanyPage = () => {
  const { t } = useTranslation();
  const team = t("kode.company.team", { returnObjects: true }) as unknown as Person[];
  const advisors = t("kode.company.advisors", { returnObjects: true }) as unknown as Person[];
  const entityRows = t("kode.company.entityRows", { returnObjects: true }) as unknown as Row[];

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>

      <main>
        {/* 01 / Company hero */}
        <PageSection marker={t("kode.company.sectionLabel")} noTop topPadClass="!pt-12">
          <h1 className="section-h-lg">{t("kode.company.h1")}</h1>
          <p className="text-body-lg text-ink-70 mt-6" style={{ maxWidth: "60ch" }}>
            {t("kode.company.lead")}
          </p>
        </PageSection>

        {/* 02 / Origin (id used as anchor target) */}
        <section id="origin" className="swiss-section">
          <div className="swiss-grid">
            <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
              <span className="swiss-num">{t("kode.company.originLabel")}</span>
            </div>
            <div className="col-span-12 lg:col-span-10 prose">
              <h2 className="section-h-lg">
                {t("kode.company.originH2Line1")}
                <br />
                {t("kode.company.originH2Line2")}
              </h2>
              <p>{t("kode.company.originP1")}</p>
              <p>{t("kode.company.originP2")}</p>
              <p>{t("kode.company.originP3")}</p>
              <p className="punch">{t("kode.company.originPunch")}</p>
            </div>
          </div>
        </section>

        {/* 03 / Team */}
        <PageSection marker={t("kode.company.teamLabel")}>
          <h2 className="section-h">{t("kode.company.teamH2")}</h2>
          <p className="section-sub">{t("kode.company.teamSub")}</p>

          <div className="team-grid">
            {team.map((p) => (
              <div className="person" key={p.name}>
                <span className="role">{p.role}</span>
                <h4>{p.name}</h4>
                <p>{p.body}</p>
              </div>
            ))}
          </div>

          <h3 className="section-h" style={{ marginTop: "4rem" }}>
            {t("kode.company.advisorsH3")}
          </h3>
          <div className="team-grid">
            {advisors.map((p) => (
              <div className="person" key={p.name}>
                <span className="role">{p.role}</span>
                <h4>{p.name}</h4>
                <p>{p.body}</p>
              </div>
            ))}
          </div>
        </PageSection>

        {/* 04 / Entity */}
        <PageSection marker={t("kode.company.entityLabel")}>
          <h2 className="section-h">{t("kode.company.entityH2")}</h2>
          <div className="lines">
            {entityRows.map(([k, v], i) => (
              <div className="row" key={i}>
                <div className="k">{k}</div>
                <div className="v">{v}</div>
              </div>
            ))}
          </div>
        </PageSection>

        <Footer />
      </main>
    </div>
  );
};

export default CompanyPage;
